import { createSelector } from 'reselect'

/**
 * Select the safewalk state slice
 * @param {object} state - Redux state
 * @returns {object} Safewalk state
 */
export const selectSafewalk = (state) => state.safewalk

/**
 * Select the safewalk contacts
 * @param {object} state - Redux state
 * @returns {Array} Contacts
 */
export const selectSafewalkContacts = createSelector(
  selectSafewalk,
  (safewalk) => safewalk.contacts
)

/**
 * Select whether the add contact form is visible
 * @param {object} state - Redux state
 * @returns {boolean} Add contact form visibility
 */
export const selectShowAddContactForm = createSelector(
  selectSafewalk,
  (safewalk) => safewalk.showAddContactForm
)

/**
 * Select the active display state
 * @param {object} state - Redux state
 * @returns {object|null} Active display state
 */
export const selectActiveDisplay = createSelector(
  selectSafewalk,
  (safewalk) => safewalk.activeDisplay
)

/**
 * Select the safewalk timer ID
 * @param {object} state - Redux state
 * @returns {string|null} Timer ID
 */
export const selectTimerId = createSelector(
  selectSafewalk,
  (safewalk) => safewalk.timerId
)

/**
 * Select the display states configuration
 * @param {object} state - Redux state
 * @returns {Array} Display states
 */
export const selectDisplayStates = createSelector(
  selectSafewalk,
  (safewalk) => safewalk.displayStates
)
